import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import {
  AppBar,
  Badge,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@material-ui/core';
import {
  AccountCircle,
  Mail,
  Menu as MenuIcon,
  Notifications,
} from '@material-ui/icons';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { IRouteStore } from '../../RouteStore';
import { IUserStore } from '../../user/UserStore';

const styles = (theme: Theme) => createStyles({
  grow: {
    flexGrow: 1,
  },
  inputInput: {
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    paddingRight: theme.spacing.unit,
    paddingTop: theme.spacing.unit,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  margin: {
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  root: {
    width: '100%',
  },
  sectionDesktop: {
    display: 'flex',
  },
  title: {
    display: 'block',
  },
});

declare type stylesKeys = 'grow' | 'inputInput' | 'inputRoot' | 'margin' | 'menuButton' | 'root' | 'sectionDesktop' | 'title';

declare interface IInjectedNavBarProps extends InjectedIntlProps {
  routeStore: IRouteStore;
  user: IUserStore;
}

class NavBar extends React.Component<IInjectedNavBarProps & WithStyles<stylesKeys>, {}> {

  public state = {
    anchorEl: null,
  };

  public render() {
    const { classes, intl: { formatMessage }, user } = this.props;
    const { anchorEl } = this.state;
    const isMenuOpen = Boolean(anchorEl);
    const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={this.handleMenuClose}
      >
        <MenuItem onClick={this.handleMenuClose}>{ formatMessage( {id: 'app.menu.profile'} )}</MenuItem>
        <MenuItem onClick={this.handleSignOut}>{ formatMessage( {id: 'app.menu.logout'} )}</MenuItem>
      </Menu>
    );

    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton className={classes.menuButton} color="inherit" aria-label="Open drawer">
              <MenuIcon/>
            </IconButton>
            <Typography className={classes.title} variant="h6" color="inherit" noWrap={true}>
              { formatMessage( {id: 'app.name'} )}
            </Typography>
            <div className={classes.grow} />
            {!user.loading &&
              <React.Fragment>
                {user.isAuthenticated
                  ? <div className={classes.sectionDesktop}>
                      <IconButton color="inherit">
                        <Badge className={classes.margin} badgeContent={4} color="secondary">
                          <Mail />
                        </Badge>
                      </IconButton>
                      <IconButton color="inherit">
                        <Badge className={classes.margin} badgeContent={17} color="secondary">
                          <Notifications />
                        </Badge>
                      </IconButton>
                      <IconButton
                        aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleProfileMenuOpen}
                        color="inherit"
                      >
                        <AccountCircle />
                      </IconButton>
                    </div>
                  : <div >
                      <Button onClick={this.handleSignIn}>
                        { formatMessage( {id: 'app.signIn'} )}
                      </Button>
                    </div>
                }
              </React.Fragment>
            }
          </Toolbar>
        </AppBar>
        {renderMenu}
      </div>
    );
  }

  private handleSignIn = () => {
    const { user } = this.props;
    user.signIn();
  }

  private handleSignOut = () => {
    const { user } = this.props;
    user.signOut();
    this.handleMenuClose();
  }

  private handleProfileMenuOpen = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  private handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

}

export default withStyles<stylesKeys>(styles)(injectIntl<InjectedIntlProps & WithStyles<stylesKeys>>(inject('routes', 'user')(observer(NavBar))));


// WEBPACK FOOTER //
// ./src/components/navbar/NavBar.tsx